import styled from "styled-components";

export const PageContainer = styled.div`
  padding: 24px;
  background: #fff;
  min-height: 100vh;
`;

export const PageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;

  h1 {
    margin: 0;
    font-size: 24px;
    font-weight: 600;
  }
`;

export const FiltersContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 24px;
  padding: 16px;
  background: #fafafa;
  border-radius: 8px;
  border: 1px solid #f0f0f0;

  .filter-item {
    min-width: 200px;
    flex: 1;
    max-width: 300px;

    .filter-label {
      display: block;
      margin-bottom: 4px;
      font-size: 12px;
      color: #666;
      font-weight: 500;
    }
  }

  .filter-actions {
    display: flex;
    align-items: flex-end;
    gap: 8px;
  }
`;

export const SelectionActionsBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  gap: 16px;

  .selection-buttons {
    display: flex;
    gap: 8px;
  }
`;

export const SelectionBanner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px 16px;
  background: #e6f7ff;
  border: 1px solid #91d5ff;
  border-radius: 4px;
  flex: 1;

  .selection-info {
    display: flex;
    align-items: center;
    gap: 8px;

    .selection-text {
      font-weight: 500;
      color: #1890ff;
    }
  }
`;

export const TableContainer = styled.div`
  .ant-table-wrapper {
    .ant-table {
      border-radius: 8px;
      overflow: hidden;
    }

    .ant-table-thead > tr > th {
      background: #fafafa;
      font-weight: 600;
    }

    .ant-table-row {
      cursor: pointer;

      &:hover {
        background: #f5f5f5;
      }

      &.selected-row {
        background: #e6f7ff;

        &:hover {
          background: #bae7ff;
        }
      }
    }
  }
`;

export const StatusTag = styled.span<{ $color: string }>`
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  background: ${(props) => props.$color}20;
  color: ${(props) => props.$color};
  border: 1px solid ${(props) => props.$color}40;
`;

export const TableFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;

  .pagination-info {
    color: #666;
    font-size: 14px;
  }

  .pagination-controls {
    display: flex;
    align-items: center;
    gap: 8px;
  }
`;

export const PaymentProgressCell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 100px;

  .progress-bar {
    height: 6px;
    background: #f0f0f0;
    border-radius: 3px;
    overflow: hidden;
  }

  .progress-fill {
    height: 100%;
    border-radius: 3px;
    transition: width 0.3s ease;
  }

  .progress-text {
    display: flex;
    justify-content: space-between;
    font-size: 11px;
    line-height: 1;

    .paid {
      font-weight: 600;
      color: #059669;
    }

    .total {
      color: #6b7280;
    }
  }
`;

export const ModalContent = styled.div`
  .analytics-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
    margin-bottom: 24px;
  }

  .analytics-card {
    padding: 16px;
    background: #fafafa;
    border-radius: 8px;
    border: 1px solid #f0f0f0;

    .analytics-label {
      font-size: 12px;
      color: #666;
      margin-bottom: 4px;
    }

    .analytics-value {
      font-size: 24px;
      font-weight: 600;
      color: #1890ff;
    }

    &.total {
      grid-column: span 2;
      text-align: center;

      .analytics-value {
        font-size: 32px;
      }
    }
  }

  .reporting-options {
    margin-top: 24px;
    padding: 16px;
    background: #fafafa;
    border-radius: 8px;
    border: 1px solid #f0f0f0;

    .option-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 12px 0;

      &:not(:last-child) {
        border-bottom: 1px solid #f0f0f0;
      }

      .option-label {
        font-weight: 500;
      }

      .option-description {
        font-size: 12px;
        color: #666;
      }
    }
  }
`;

